import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer } from "../../components/Footer";
import Header from "../../components/Header";
import patient from "../../assets/img/patient.jpg";
import { useEffect, useState } from "react";
import { CallWithAuth } from "../../action/apiActions";
import {
  GET_PATIENT_RELATIVES_API_URL,
  SEND_MAIL_PATIENT_RELATIVES_API_URL,
} from "../../action/apiPath";
import { fileName, textRetriever } from "../../util/custom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { showToast, ToastContainer } from "../../util/toastHelper";
import { GiDiscussion } from "react-icons/gi";
import { FaSlideshare } from "react-icons/fa";
import { VscPreview } from "react-icons/vsc";
import { MdOutlineWorkHistory } from "react-icons/md";
import { MdOutlineManageHistory } from "react-icons/md";
import { TbSocial } from "react-icons/tb";
import { IoSchoolOutline } from "react-icons/io5";
import { PiTestTubeDuotone } from "react-icons/pi";
import { TiDocumentText } from "react-icons/ti";
import { MdOutlineSocialDistance } from "react-icons/md";
import { MdOutlinePsychology } from "react-icons/md";
import { MdAssignmentAdd } from "react-icons/md";
import { RxFace } from "react-icons/rx";
import { FaSignature } from "react-icons/fa";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { Box } from "@mui/material";
import { IoMdMore } from "react-icons/io";
import { TbFileUpload } from "react-icons/tb";
import { RELATIVE_INTAKE_FORM_URL } from "../../util/path";

const MySwal = withReactContent(Swal);
const staticRelatives = [
  {
    id: 1,
    name: "Srikanth Y",
    email: "test1@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 2,
    name: "Srikanth G",
    email: "test2@yopmail.com",
    phone: "1236547890",
    isChecked: false,
  },
  {
    id: 3,
    name: "Srikanth M",
    email: "test3@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
  {
    id: 4,
    name: "Srikanth M",
    email: "test4@yopmail.com",
    phone: "1236547890",
    isChecked: true,
  },
];
/**
 * The Patient Relatives Information Page component
 * @returns {JSX.Element} The component
 */
const PatientRelativesInformationPage = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [getRelativesData, setRelativesData] = useState([]);
  const [getRelativesDocs, setRelativesDocs] = useState([]);

  const [getRelativesDataDeatil, setRelativesDataDeatil] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (id == undefined || id == "") {
      navigate("/");
      return;
    }
    getReleatives();
  }, [id]);

  /**
   * Fetch the relatives data from the API
   * @param {string} id The patient id
   * @returns {Promise<void>}
   */
  const getReleatives = async () => {
    try {
      /**
       * The API endpoint to fetch the relatives data
       * @type {string}
       */
      const url = `${GET_PATIENT_RELATIVES_API_URL}/${id}/?extra=true`;

      const response = await CallWithAuth("GET", url);

      if (response.res.data && response.res.data.statusCode === 200) {
        /**
         * The relatives data fetched from the API
         * @type {Array<Object>}
         */
        setRelativesData(response.res.data.data.relatives ?? []);
        setRelativesDocs(response.res.data.data.reports ?? []);
        setRelativesDataDeatil(response.res.data.data);
      }
      setIsLoading(false);
    } catch (error) { }
  };

  /**
   * Handle the check box click event for a relative
   * @param {number} id The relative id
   * @returns {void}
   */
  const handleCheck = (id) => {
    /**
     * Update the relatives data state with the new checked value
     * @param {Array<Object>} prevRelatives The previous relatives data
     * @returns {Array<Object>} The updated relatives data
     */
    setRelativesData((prevRelatives) =>
      prevRelatives.map((relative) =>
        relative.id === id
          ? { ...relative, isChecked: !relative.isChecked }
          : relative
      )
    );
  };
  const handleCheckDoc = (id) => {
    setRelativesDocs((prevDocs) =>
      prevDocs.map((doc) =>
        doc.id === id ? { ...doc, isChecked: !doc.isChecked } : doc
      )
    );
  };

  /**
   * Handle the send mail action for selected relatives and documents
   * @returns {Promise<void>}
   */
  const handleSendMail = async () => {
    // Check if at least one relative is selected
    const selectedRelatives = getRelativesData.some(
      (relative) => relative.isChecked
    );
    if (!selectedRelatives) {
      showToast("error", "Please select a relative to send an email");
      return;
    }

    // // Check if at least one document is selected
    // const selectedDocs = getRelativesDocs.some(
    //   (doc) => doc.isChecked
    // );
    // // console.log("140", getRelativesDocs, getRelativesData);

    // if (!selectedDocs) {
    //   showToast("error", "Please select a document to send an email");
    //   return;
    // }

    // Confirm the action with the user
    const result = await MySwal.fire({
      title: "Are you sure want to send email selected Patient's Contacts?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
    });

    if (result.isConfirmed) {
      // Gather IDs of selected relatives
      const selectedRelativeId = getRelativesData
        .filter((relative) => relative.isChecked)
        .map((relative) => relative.id);

      // Gather IDs of selected documents
      const selectedDocId = getRelativesDocs
        .filter((doc) => doc.isChecked)
        .map((doc) => doc.id);

      // Prepare data for the API call
      const data = {
        patient_id: id,
        relative_ids: selectedRelativeId,
        doc_ids: selectedDocId,
      };

      setIsLoading(true);
      // Send email with the selected data
      await sendMail(data);
    }
  };

  /**
   * Send an email to selected patient relatives with selected documents.
   * @param {Object} data - The data containing patient ID, relative IDs, and document IDs.
   * @param {number} data.patient_id - The ID of the patient.
   * @param {Array<number>} data.relative_ids - The array of relative IDs to send the email to.
   * @param {Array<number>} data.doc_ids - The array of document IDs to include in the email.
   * @returns {Promise<void>}
   */
  const sendMail = async (data) => {
    try {
      // Make a POST request to send mail to the specified relatives with documents
      const response = await CallWithAuth(
        "POST",
        `${SEND_MAIL_PATIENT_RELATIVES_API_URL}/${data.patient_id}`,
        {
          relative_ids: data.relative_ids,
          document_ids: data.doc_ids,
        }
      );

      // Check the response status and show a toast message accordingly
      if (response?.res?.data?.statusCode === 200) {
        showToast("success", response?.res?.data?.message);
      } else if (response?.res?.data?.statusCode === 400) {
        showToast("error", response?.res?.data?.message);
      }

      // Set loading state to false after the response is handled
      setIsLoading(false);
    } catch (error) {
      // Log error to the console and set loading state to false
      console.error("Error sending mail:", error);
      console.error("Error fetching practice frameworks:", error);
      setIsLoading(false);
    }
  };
  /**
   * Handle the send mail action for all relatives and selected documents
   * @returns {Promise<void>}
   */
  const handleSendMailAllUser = async () => {
    // Confirm the action with the user
    const result = await MySwal.fire({
      title: "Are you sure want to send email all Patient's Contacts?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
    });

    if (result.isConfirmed) {
      // Gather IDs of all relatives
      const selectedRelativeId = getRelativesData
        .filter((relative) => relative)
        .map((relative) => relative.id);

      // Gather IDs of selected documents
      const selectedDocId = getRelativesDocs
        .filter((doc) => doc.isChecked)
        .map((doc) => doc.id);

      // Prepare data for the API call
      const data = {
        patient_id: id,
        relative_ids: selectedRelativeId,
        doc_ids: selectedDocId,
      };

      setIsLoading(true);
      // Send email with the selected data
      await sendMail(data);
    }
  };
  const handleClickBack = async () => {
    navigate("/patient-information");
  }

  const AddIntakeForm = async () => {
    navigate(`/add-paitent-intake/${id}`);
  }
  return (
    <>
      {isLoading && (
        // <><h1 className="text-center">Report loading...</h1></>
        <>
          <div className="full-page-loader">
            <div className="loader"></div>
          </div>
        </>
      )}
      <div className="front-end-dashboard">
        <div className="site_container">


          <div className="dashboard-page-header">
            <div className="left-div">
              <h3>Added Patient's Contacts List</h3>
              <p>E-Mail Send to Patient's Contacts</p>
            </div>
            <div className="right-div">
              {getRelativesData.length > 0 && (
                <button className="send_mail_button" onClick={handleSendMail}>
                  Send Mail Selected Patient's Contacts
                </button>
              )}

              {getRelativesData.length > 0 && (
                <button
                  className="send_mail_button"
                  onClick={handleSendMailAllUser}
                >
                  Send Mail All Patient's Contacts
                </button>
              )}
              {
                !getRelativesDataDeatil?.is_form_submitted && (
                  <button
                    className="send_mail_button"
                    onClick={AddIntakeForm}
                  >
                    Add Paitent Intake form
                  </button>
                )
              }

              <button
                className="send_mail_button"
                onClick={handleClickBack}
              >
                Back
              </button>
            </div>
          </div>

          <div className="dashboard-page-body">
            <div className="dashboard-common-details-wrapper">
              <div className="custom-white-card">
                <ul className="ciw-content-list-s1">
                  {getRelativesDataDeatil.signature && (
                    <li>
                      <div className="icon-container">
                        <FaSignature />
                      </div>
                      <div className="text-container">
                        <label>Patient Signature:</label>
                        <div className="value">
                          <a
                            href={`${getRelativesDataDeatil.signature}`} // Full URL for S3 file
                            target="_blank" // Opens link in a new tab
                            rel="noopener noreferrer" // Security best practice
                            className="edit"
                          >
                            <i className="fa-solid fa-eye"></i>
                          </a>
                        </div>
                      </div>
                    </li>
                  )}

                  {getRelativesDataDeatil.face_image && (
                    <li>
                      <div className="icon-container">
                        <RxFace />

                      </div>
                      <div className="text-container">
                        <label>Face Image:</label>
                        <div className="value"> <a
                          href={`${getRelativesDataDeatil.face_image}`} // Full URL for S3 file
                          target="_blank" // Opens link in a new tab
                          rel="noopener noreferrer" // Security best practice
                          className="edit"
                        >
                          <i className="fa-solid fa-eye"></i>
                        </a>
                        </div>
                      </div>
                    </li>
                  )}

                  <li>
                    <div className="icon-container">
                      <GiDiscussion />
                    </div>
                    <div className="text-container">
                      <label>Relative consent:</label>
                      <div className="value">{getRelativesDataDeatil?.relative_consent
                        ? "Share-and-obtain with and from 3rd party"
                        : "Obtain-only from 3rd party"}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <FaSlideshare />
                    </div>
                    <div className="text-container">
                      <label>Referral Information:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.referral_info)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <VscPreview />
                    </div>
                    <div className="text-container">
                      <label>Presenting Concerns:</label>
                      <div className="value"> {textRetriever(getRelativesDataDeatil?.present_concern)}</div>
                    </div>
                  </li>


                  <li>
                    <div className="icon-container">
                      <MdOutlineWorkHistory />
                    </div>
                    <div className="text-container">
                      <label>Medical and Psychiatric History:</label>
                      <div className="value">{/* {getRelativesDataDeatil?.referral_info ?? "N?A"} */}
                        {textRetriever(getRelativesDataDeatil?.medical_history)}</div>
                    </div>
                  </li>
                  <li>
                    <div className="icon-container">
                      <MdOutlineManageHistory />
                    </div>
                    <div className="text-container">
                      <label>Developmental History:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.developmental_history)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <TbSocial />
                    </div>
                    <div className="text-container">
                      <label>Family and Social History:</label>
                      <div className="value">{/* {getRelativesDataDeatil?.referral_info ?? "N?A"} */}
                        {textRetriever(getRelativesDataDeatil?.family_history)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <IoSchoolOutline />
                    </div>
                    <div className="text-container">
                      <label>Educational/Occupational History:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.social_history)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <PiTestTubeDuotone />
                    </div>
                    <div className="text-container">
                      <label>Substance Use History:</label>
                      <div className="value">{/* {getRelativesDataDeatil?.referral_info ?? "N?A"} */}
                        {textRetriever(getRelativesDataDeatil?.substance_use_history)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <TiDocumentText />
                    </div>
                    <div className="text-container">
                      <label>Legal History:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.legal_history)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <MdOutlineSocialDistance />
                    </div>
                    <div className="text-container">
                      <label>Cultural and Social Context:</label>
                      <div className="value">{/* {getRelativesDataDeatil?.referral_info ?? "N?A"} */}
                        {textRetriever(getRelativesDataDeatil?.cultural_context)}</div>
                    </div>
                  </li>

                  <li>
                    <div className="icon-container">
                      <MdOutlinePsychology />
                    </div>
                    <div className="text-container">
                      <label>Experience of Significant Psychosocial Trauma:</label>
                      <div className="value">{textRetriever(getRelativesDataDeatil?.phychosocial_trauma)}</div>
                    </div>
                  </li>
                  <li>
                    <div className="icon-container">
                      <MdAssignmentAdd />
                    </div>
                    <div className="text-container">
                      <label>Additional Information:</label>
                      <div className="value">{/* {getRelativesDataDeatil?.referral_info ?? "N?A"} */}
                        {textRetriever(getRelativesDataDeatil?.additional_info)}</div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="w-full">
                <div className="custom-white-card">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      {/* First Table */}
                      <div className="table-wrapper">
                        <div className="ciw-bottom-se-headerpart">
                          <div className="lebox">
                            <h4>Patient's Contacts</h4>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <table className="table patient-row-details">
                            <thead>
                              <tr>
                                <th>Select</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {getRelativesData?.length && !isLoading
                                ? getRelativesData?.map((relative, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={relative.isChecked}
                                        onChange={() => handleCheck(relative.id)}
                                      />
                                    </td>
                                    <td>
                                      <label>{relative.name}</label>
                                    </td>
                                    <td>
                                      <label htmlFor="">{relative.email}</label>
                                    </td>
                                    <td>
                                      <label htmlFor="">{relative.phone}</label>
                                    </td>

                                    <td>
                                      <Link
                                        // to={`/relatives-submit-detail/${relative.id}`} 
                                        to={
                                          typeof relative.patient_relevant_extra_info !== "object"
                                            ? `/relatives-submit-detail/${relative.id}`
                                            : "#"
                                        }
                                        target="_blank" // Opens link in a new tab
                                        rel="noopener noreferrer" // Security best practice
                                        // className="edit"
                                        className={`edit ${!relative.patient_relevant_extra_info ||
                                          relative.patient_relevant_extra_info === null ||
                                          typeof relative.patient_relevant_extra_info === "object"
                                          ? "disabled-link"
                                          : ""
                                          }`}
                                        onClick={(e) => {
                                          if (
                                            !relative.patient_relevant_extra_info ||
                                            relative.patient_relevant_extra_info === null ||
                                            typeof relative.patient_relevant_extra_info === "object"
                                          ) {
                                            e.preventDefault(); // Prevent navigation if disabled
                                          }
                                        }}

                                      >
                                        <i className="fa-solid fa-eye"></i>
                                      </Link>{" "}
                                    </td>
                                  </tr>
                                ))
                                : null}

                              {getRelativesData?.length == 0 && !isLoading && (
                                <>
                                  <td colSpan={5} style={{ textAlign: "center" }}>
                                    No data Found
                                  </td>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      {/* New Table */}
                      <div className="table-wrapper">
                        <div className="ciw-bottom-se-headerpart">
                          <div className="lebox">
                            <h4>Documents</h4>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table patient-row-details">
                            <thead>
                              <tr>
                                <th>Select</th>
                                <th>File path</th>
                                <th className="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {getRelativesDocs.map((doc) => (
                                <tr key={doc.id}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={doc.isChecked}
                                      disabled={!getRelativesDataDeatil?.relative_consent}
                                      onChange={() => handleCheckDoc(doc.id)}
                                    />
                                  </td>
                                  <td><span className="d-block text-break">{fileName(doc.file)}</span></td>
                                  <td>
                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                      {(popupState) => (
                                        <>
                                          <button type="button" className="more-action-btn" {...bindTrigger(popupState)}>
                                            <IoMdMore />
                                          </button>
                                          <Menu {...bindMenu(popupState)} className='theme-menu-dropdown-s1'
                                            anchorOrigin={{
                                              vertical: 'bottom',
                                              horizontal: 'right',
                                            }}
                                            transformOrigin={{
                                              vertical: 'top',
                                              horizontal: 'right',
                                            }}>

                                            <a
                                              href={`${doc.file}`} // Full URL for S3 file
                                              target="_blank" // Opens link in a new tab
                                              rel="noopener noreferrer" // Security best practice
                                              className="MuiButtonBase-root"
                                            >
                                              <Box className="icon-container">
                                                <TbFileUpload />

                                              </Box>
                                              <Box className="text-container">
                                                Upload Report File
                                              </Box>
                                            </a>

                                          </Menu>
                                        </>
                                      )}
                                    </PopupState>

                                  </td>
                                </tr>
                              ))}
                              {getRelativesDocs?.length == 0 && !isLoading && (
                                <>
                                  <td colSpan={4} style={{ textAlign: "center" }}>
                                    No data Found
                                  </td>
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};
export default PatientRelativesInformationPage;
